import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Table, Space } from 'antd';

import useDatasource from '../../hooks/useDatasource';
import Column from '../../helpers/columns';
import {
  findAll,
  downloadAll,
} from '../../services/validators/inspector-devices';
import ExportEntitiesButton from '../buttons/ExportEntitiesButton';
import PageTitle from '../PageTitle';

const InspectorDevicesList = () => {
  const { t } = useTranslation();

  const { pagination, criterias, content, handleChange, sort } =
    useDatasource(findAll);

  const columns = useMemo(
    () => [
      Column.text('serialNo', t('components.inspectors.gpsLocation.serialNo'), {
        filter: true,
      }),
      Column.text(
        'inspectorId',
        t('components.inspectors.gpsLocation.inspectorId'),
        { filter: true },
      ),
      Column.text(
        'inspectorFullname',
        t('components.inspectors.gpsLocation.inspectorFullname'),
        { filter: true },
      ),
      Column.text(
        'softwareVersion',
        t('components.inspectors.gpsLocation.softwareVersion'),
        { filter: true },
      ),
      Column.text(
        'gpsLatitude',
        t('components.inspectors.gpsLocation.gpsLatitude'),
        { filter: true },
      ),
      Column.text(
        'gpsLongitude',
        t('components.inspectors.gpsLocation.gpsLongitude'),
        { filter: true },
      ),
      {
        ...Column.date(
          'updatedAt',
          t('components.inspectors.gpsLocation.updatedAt'),
          { filter: true },
        ),
        ellipsis: true,
      },
    ],
    [t],
  );

  return (
    <>
      <PageTitle>
        <Space>
          <ExportEntitiesButton
            columns={columns}
            data={{
              sort,
              criterias,
            }}
            downloadFiles={downloadAll}
          />
        </Space>
      </PageTitle>
      <Table
        rowKey="id"
        columns={columns}
        pagination={pagination}
        dataSource={content}
        onChange={handleChange}
        scroll={{ x: 700, y: 700 }}
        size="small"
      />
    </>
  );
};

export default InspectorDevicesList;
